import { defineComponent as _defineComponent } from 'vue'
import { ref, watchEffect } from "vue"

interface FilterDropdownProps {
  closed?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  props: {
    closed: { type: Boolean, default: false }
  },
  emits: ['toggle'],
  setup(__props: any, { emit }) {

const props = __props as { closed: boolean };





const isClosed = ref(false)

const toggleClosed = ():void => {
  isClosed.value = !isClosed.value;

  emit("toggle", isClosed.value)
}

watchEffect(() => {
  isClosed.value = props.closed
})


return { __sfc: true,props, emit, isClosed, toggleClosed }
}

})